import z from 'zod';

import { InsuranceType } from '@/models/insurance.ts';

export const stepEligiblePractitioner = z.object({
    practitioner_id: z.string(),
    practitioner_pms_id: z.string(),
    calendar_pms_ids: z.array(z.string()),
    display_name: z.string(),
});

export const appointmentChainConfigurationSchema = z
    .object({
        id: z.string(),
        instance_id: z.string(),
        customer_id: z.string(),
        name: z.object({
            en: z.string(),
            de: z.string(),
        }),
        description: z
            .object({
                de: z.string(),
            })
            .optional(),
        practice_id: z.string(),
        insurance_types: z.array(z.enum(InsuranceType)).min(1),
        is_for_new_patients: z.boolean(),
        is_bookable_by_patient: z.boolean().default(false),
        is_for_returning_patients: z.boolean(),
        steps: z.array(
            z.object({
                order: z.number(),
                appointment_type_id: z.string(),
                is_main_practitioner: z.boolean().default(false),
                eligible_practitioners: z.array(stepEligiblePractitioner).optional(),
            })
        ),
        gaps: z.array(
            z.object({
                from_step: z.number(),
                to_step: z.number(),
                min_duration: z.iso.duration(),
                max_duration: z.iso.duration().optional(),
            })
        ),
        meta: z.object({
            created_at: z.string(),
            updated_at: z.string(),
            deleted_at: z.string().optional(),
        }),
    })
    .refine((cfg) => cfg.is_for_new_patients || cfg.is_for_returning_patients, {
        message: 'At least one patient type must be selected',
        path: ['is_for_returning_patients'],
    });

export type AppointmentChainConfiguration = z.infer<typeof appointmentChainConfigurationSchema>;
export type StepEligiblePractitioner = z.infer<typeof stepEligiblePractitioner>;
